






import Vue from "vue";
import FormComponentMixin from "@/plugins/FormComponentMixin";
export default Vue.extend({
  mixins: [FormComponentMixin],
  props: {
    path: { type: String }
  },
  data() {
    return {
      isLoading: false,
      violations: {},
      phase: "input"
    };
  }
});
